import { useIntl } from "react-intl";
import React, { MouseEventHandler } from "react";
import ListItem from "./ListItem";
import ListSeparator from "./ListSeparator";

import "./list.scss";

interface ListItemInterface {
  title: JSX.Element | string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

function List({ list }: { list: ListItemInterface[] }) {
  const { formatMessage } = useIntl();

  return (
    <div className="list">
      {list.length > 0 ? (
        list.map(({ title, className, onClick }, i) => (
          <React.Fragment key={i}>
            {i > 0 && <ListSeparator />}
            <ListItem title={title} onClick={onClick} className={className} />
          </React.Fragment>
        ))
      ) : (
        <span className="list-item not-found">
          {formatMessage({ id: "common.not_found" })}
        </span>
      )}
    </div>
  );
}

export default List;
